export default __webpack_public_path__ + "static/media/price-100.829f3025.png";